import React from 'react';
import styled, {css} from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

import {H6} from '../atoms/TextComponents';
import Section from '../atoms/Section/Section';
import {getColors, maxMediaQueries} from '../utils/styling';

const SliderContainer = styled('div')`
  ${maxMediaQueries.sm`
    padding: 0 30px
  `};
`;

const SlideWrapper = styled('div')`
  &:active, &:focus {
    outline: none;
  }
  
  span {
    display: block;
    position: relative;
    border-radius: 4px;
    margin: 0 12px;
    padding: 24px;
    height: 50px;
    box-sizing: content-box;
    ${({theme}) => css`background: ${getColors(theme).gray200}`};
    
  }
  
  a:active, &:focus {
    outline: none;
  }  
  
  img { 
    height: 100%;
  }
`;

const LogoSlider = ({customerLogos}) => {
  const settings = {
    lazyLoad: true,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    adaptiveHeight: true,
    variableWidth: true,
    infinite: true,
    appendDots: () => null,
    arrows: false,
    autoplaySpeed: 4000,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ],
    customPaging: () => ''
  };
  return (
      <Section margin>
        <SliderContainer>
          <H6 className="text-center" color="gray600">Trusted by</H6>
          <Slider {...settings}>
            {customerLogos.filter(logo => logo && logo.balancedLogoColor).map((logo, index) =>
                (
                    <SlideWrapper key={index}>
                  <span>
                    <img src={logo.balancedLogoColor.file.url} alt={logo.customerName}/>
                  </span>
                    </SlideWrapper>
                )
            )}
          </Slider>
        </SliderContainer>
      </Section>
  );
};

export default LogoSlider;
